import { render, staticRenderFns } from "./PremiumDateTimePicker.vue?vue&type=template&id=2bfaf964&scoped=true"
import script from "./PremiumDateTimePicker.vue?vue&type=script&lang=js"
export * from "./PremiumDateTimePicker.vue?vue&type=script&lang=js"
import style0 from "./PremiumDateTimePicker.vue?vue&type=style&index=0&id=2bfaf964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfaf964",
  null
  
)

export default component.exports